const TOKEN_KEY = "ecp.backendToken";
const RETURN_KEY = "ecp.dastReturn";

export function safeDastDestination(value) {
    if (typeof value !== "string" || !/^\/dast(?:\?|$)/.test(value)) return null;
    const url = new URL(value, "https://frontend.invalid");
    return url.pathname === "/dast" ? `${url.pathname}${url.search}` : null;
}

export function readBackendToken() {
    try { return sessionStorage.getItem(TOKEN_KEY) || null; } catch { return null; }
}

export function storeBackendToken(token) {
    try {
        if (token) sessionStorage.setItem(TOKEN_KEY, token);
        else sessionStorage.removeItem(TOKEN_KEY);
    } catch { /* Authentication can still work in memory. */ }
}

export function rememberDastDestination() {
    const destination = safeDastDestination(`${window.location.pathname}${window.location.search}`);
    if (destination) {
        try { sessionStorage.setItem(RETURN_KEY, destination); } catch { /* The current URL is also retained. */ }
    }
}

export function restoreDastDestination() {
    try {
        const destination = safeDastDestination(sessionStorage.getItem(RETURN_KEY));
        if (destination && window.location.pathname === "/") window.history.replaceState(null, "", destination);
        sessionStorage.removeItem(RETURN_KEY);
    } catch { /* No saved destination is required for an explicit return URL. */ }
}
